import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function CompletionCheck({ allocation, disabled }: Props) {
  const isCompleted = allocation.percentComplete === 100;

  return (
    <div
      className={classNames(styles.taskCompletionStatus, {
        [styles.progressed]: allocation.percentComplete < 100,
        [styles.completed]: isCompleted,
        [styles.disabled]: disabled,
      })}
    />
  );
}

export { CompletionCheck };
